import { getAllHubOwners } from '../../../contracts/data/datasources/get-hub-owners';
import { getDriver } from './get-driver';

/**
 * The driver's hubs with their names, own hubs included. A permission whose owner or hub can't be named (no contract,
 * hub deleted) is left out, as cb left out what it couldn't resolve.
 */
export const getDeliveryPermissions = async (driver_id: string): Promise<any[]> => {
  const [driver, owners] = await Promise.all([getDriver(driver_id), getAllHubOwners()]);

  return (driver.delivery_permissions || []).flatMap(({ promisor_id, hub_id }: any) => {
    const owner = owners.find(({ id }) => id === promisor_id);
    const hub = owner?.hubs.find(({ id }: any) => id === hub_id);

    return owner && hub
      ? [{ promisor: { id: promisor_id, name: owner.name }, hub: { id: hub_id, name: hub.name } }]
      : [];
  });
};
